"use client";
import { CartAlt } from "iconoir-react";
import { type JSX } from "react";
import { useCart } from "@/cart";
import { getCartNumberOfItems } from "../selectors";
import classNames from "classnames";

export function OpenCartButton({
  className,
  ...rest
}: Omit<JSX.IntrinsicElements["button"], "onClick">) {
  const { openCart, cart, cartDisabled } = useCart();
  const numberOfItems = getCartNumberOfItems(cart);
  if (cartDisabled === true) return null;
  return (
    <button
      onClick={openCart}
      data-item-count={numberOfItems}
      className={classNames(
        "relative flex size-10 cursor-pointer items-center justify-center self-center lg:size-8",
        {
          "before:absolute before:-right-0.5 before:bottom-2 before:flex before:h-4 before:w-4 before:items-center before:justify-center before:rounded-full before:bg-red-500 before:cvr-title-xs before:text-white before:content-[attr(data-item-count)] lg:before:-right-1.5 lg:before:bottom-1":
            numberOfItems > 0,
        },
        className,
      )}
      {...rest}
    >
      <span className="sr-only">{`Se handlekurv - ${numberOfItems} vare${
        numberOfItems > 1 ? "r" : ""
      }`}</span>
      <CartAlt width={24} height={24} className="lg:size-[18px]" />
    </button>
  );
}
